export const environment = {
  production: false,

  // API_URL: "https://mvsalphaplatform-mvs-platform-dev.azuremicroservices.io", // Gateway Development Server
  // tenant: "tenantA"

  //API_URL: "https://mvsalphaplatform-mvs-gateway.azuremicroservices.io/dev_ex", // Gateway Development Server
  API_URL: "https://alpha-prod-gateway.calmforest-6dbf5289.germanywestcentral.azurecontainerapps.io/dev_ex", // Gateway Development Server
  tenant: null


};
